<template>
<div class="nj-info">
    <div :class="classLabel">{{ label }}:</div>
    <div :class="classText">
        <slot></slot>
    </div>
</div>
</template>

<script>
export default {
    name: "Info",
    props: {
        label: {
            required: true
        },
        direction: {
            type: String,
            default: "left"
        }
    },
    computed: {
        classLabel() {
            return 'nj-info--label ' + this.direction
        },
        classText() {
            return 'nj-info--value ' + this.direction
        }
    }
}
</script>

<style scoped>
.nj-info {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    gap: 0;
    margin: 0 0 6px 0;
}

.nj-info--label {
    font-weight: bold;
    display: block;
    padding: 4px 4px 2px 4px;
}

.left {
    text-align: left;
}

.right {
    text-align: right;
}

.nj-info--value {
    display: block;
    padding: 2px 4px 4px 4px;
}
</style>